import React, {Component} from 'react';
import { Link } from "react-router-dom";
// import { Link as ScrollLink, Element } from "react-scroll";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

// import architech from "../Survey/images/architecs.jpg";
// import workspace from "../Survey/images/workspace.jpg";

// import styles from "./styles/TalentHome.scss"

export default class HomePage extends Component {

  bringToTop = () => {
    window.scrollTo(0,0);
  }

  render () {
    window.onload = this.bringToTop();

    return (
      <div>
        <div style={{textAlign: 'center'}}>
          <div className="row justify-content-center mx-auto" style={{width: '100%'}}>
            <Link to="/kingstonconnect" className='col-sm-3 py-2'>
              <button style={{height: '85%', width: '100%'}} className="btn btn-outline-primary btn-lg" type='button'> <h3>Login / Sign Up </h3></button>
            </Link>
            <Link to="/kingstonhome/invite" onClick={this.bringToTop} className='col-sm-3 py-2'>
              <button style={{height: '85%', width: '100%'}} className="btn btn-outline-primary btn-lg" type='button'> <h3>Nominate</h3></button>
            </Link>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/HomePage.js